import React, { useState } from 'react';
import Modal from "react-modal";
import Swal from 'sweetalert2';
import { approveItem, reproveItem } from '../../services/ficha.service';

export default function ReproveModal({ isOpen, handleCancelModal, item }) {
  const [rejectReason, setReason] = useState();
  const [isLoadingChange, setisLoadingChange] = useState(false);

  const handleSave = () => {
    setisLoadingChange(true);
    handleReproveItem();
    setisLoadingChange(false);
    handleCancelModal();
  }

  const handleReproveItem = async () => {
    Swal.fire({
      title: "<strong>Reprovar ficha</strong>",
      icon: "question",
      html: "Deseja reprovar a ficha? ",
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim!',
      cancelButtonText: "Não",
    }).then(async (result) => {
      if (result.value) {
        console.log('item', item);
        await reproveItem(item.id, { reproveReason: rejectReason });
      }
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      style={{
        content: {
          width: "40%",
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          marginRight: "-50%",
          transform: "translate(-50%, -50%)",
        },
      }}
      contentLabel="Modal reprovação de cadastros"
    >
      <div className="row">
        <div className="col-12">
          <h3>Informe o motivo de reprovação da Ficha</h3>
          <div className="form-group">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="form-group">
                    <label htmlFor="exampleInputEmail1">Motivo (max 250 caracteres)</label>
                    <textarea
                      className="form-control"
                      value={rejectReason}
                      onChange={(e) => setReason(e.target.value)}
                    />
                    {/* <small id="emailHelp" className="form-text text-muted">Nunca vamos compartilhar seu email, com ninguém.</small> */}
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="form-group">
            <button className="btn btn-primary" onClick={() => handleCancelModal()}>
              Cancelar
            </button>
            &nbsp;
            <button
              className="btn btn-success"
              onClick={handleSave}
            >
              <span className={isLoadingChange ? " spinner-border spinner-border-sm" : ""}></span>{" "}
              Salvar
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}
